import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FilesAiIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.53 4.47L17.53 0.47C17.39 0.33 17.2 0.25 17 0.25H4C3.04 0.25 2.25 1.04 2.25 2V22C2.25 22.96 3.04 23.75 4 23.75H20C20.96 23.75 21.75 22.96 21.75 22V5C21.75 4.8 21.67 4.61 21.53 4.47ZM20.25 22C20.25 22.14 20.14 22.25 20 22.25H4C3.86 22.25 3.75 22.14 3.75 22V2C3.75 1.86 3.86 1.75 4 1.75H16.69L20.25 5.31V22Z"
        fill={color}
      />
      <path
        d="M12.57 7.75C12.47 7.52 12.25 7.37 12 7.37C11.75 7.37 11.53 7.52 11.43 7.75L10.01 11.01L6.75 12.43C6.52 12.53 6.37 12.75 6.37 13C6.37 13.25 6.52 13.47 6.75 13.57L10.01 14.99L11.43 18.25C11.53 18.48 11.75 18.63 12 18.63C12.25 18.63 12.47 18.48 12.57 18.25L13.99 14.99L17.25 13.57C17.48 13.47 17.63 13.25 17.63 13C17.63 12.75 17.48 12.53 17.25 12.43L13.99 11.01L12.57 7.75ZM13.27 13.94C13.12 14 13.01 14.12 12.95 14.26L12.01 16.43L11.07 14.26C11.01 14.11 10.89 14 10.75 13.94L8.58 13L10.75 12.06C10.9 12 11.01 11.88 11.07 11.74L12.01 9.56999L12.95 11.74C13.01 11.89 13.13 12 13.27 12.06L15.44 13L13.27 13.94Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FilesAiIcon.displayName = 'FilesAiIcon';
